import { customerTaxCodeLabels } from './constants'

const getCustomerPhone = (customerProfile, address) => {
  return customerProfile?.phone?.prefix || customerProfile?.phone?.number ? customerProfile.phone : address?.phone
}

export const getCustomerProfile = ({ customerProfile, email, address }) => {
  return {
    ...customerProfile,
    email,
    phone: getCustomerPhone(customerProfile, address),
  }
}

export const getCustomerTaxCodeLabel = (customerTaxCode, t) => {
  const label = customerTaxCodeLabels[customerTaxCode.type]

  if (!label) return customerTaxCode.title

  return t(label)
}
